import { FC, Suspense } from 'react';
import { Outlet } from 'react-router';

import { SiteHeader } from '~widgets/shared/site-header';
import { SiteFooter } from '~widgets/shared/site-footer';

export interface SiteLayoutProps extends Partial<ComponentWithChildren> {}

export const SiteLayout: FC<SiteLayoutProps> = ({ children }) => {
  return (
    <>
      <SiteHeader />
      <div className="min-h-[80vh] h-full m-auto overflow-x-hidden">
        <Suspense fallback="loading">
          {children} <Outlet />
        </Suspense>
      </div>
      <SiteFooter />
    </>
  );
};
